import { type PillarFormInputComponentConfig } from "shared/components/pillar-form/PillarFormInputComponentConfig";

export enum WorkflowActionRoles {
  Admin = "Admin",
  User = "User",
}
export enum WorkflowActionType {
  MODAL = "modal",
  FORM = "form",
  HYPERLINK = "hyperlink",
}
export type WorkflowAction =
  | WorkflowActionForm
  | WorkflowActionModal
  | WorkflowActionHyperlink;
export interface WorkflowActionBase {
  type: WorkflowActionType;
  roles: WorkflowActionRoles[];
  setState?: string;
  event: string;
  title: string;
  className?: string;
  userHubEvaluation?: WorkflowActionUserHubEvaluation;
}
export interface WorkflowActionUserHubEvaluation {
  actionEnableEvaluation?: string; // expression that evaluates to boolean to enable/disable the action
  classNameEvaluation?: string; // expression that evaluates to boolean to determine which className to use
  classNameTrue?: string; // className to use if classNameEvaluation evaluates to true
  classNameFalse?: string; // className to use if classNameEvaluation evaluates to false
}

export interface WorkflowActionModal extends WorkflowActionBase {
  type: WorkflowActionType.MODAL;
  title: string;
  message: string;
  confirmText: string;
  cancelText: string;
  // Configuration for form elements presented for this possible action
  formElements?: PillarFormInputComponentConfig[];
}

export interface WorkflowActionHyperlink extends WorkflowActionBase {
  type: WorkflowActionType.HYPERLINK;
  userHubRoute: string;
}

export interface WorkflowActionForm extends WorkflowActionBase {
  type: WorkflowActionType.FORM;
  userhubFormRoute: string;
  endpoint?: string;
  actionName?: string;
}
